import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TreeViewLocation } from "./components/TreeViewLocation";

export const CatalogLocationPage = () => (
	<DndProvider backend={HTML5Backend}>
		<TreeViewLocation />
	</DndProvider>
);
